import React, { useEffect, useState } from "react";
import axiosInstance from "../../utils/axiosInstance";
import { API_PATHS, BASE_URL } from "../../utils/apiPaths";
import { LuUsers } from "react-icons/lu";
import Modal from "../../components/Modal";
import AvatarGroup from "../AvatarGroup";

const SelectUsers = ({ selectedUsers, setSelectedUsers }) => {
  const [allUsers, setAllUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tempSelectedUsers, setTempSelectedUsers] = useState([]);

  // 🧠 Récupération des utilisateurs
  const getAllUsers = async () => {
    try {
      const response = await axiosInstance.get(API_PATHS.USERS.GET_ALL_USERS);
      if (response.data?.length > 0) {
        setAllUsers(response.data);
      }
      console.log("Utilisateurs chargés :", response.data);
    } catch (error) {
      console.log("Erreur lors du chargement des utilisateurs :", error);
    }
  };

  // ✅ Chargement initial
  useEffect(() => {
    getAllUsers();
  }, []);

  // 🧩 Gestion de la sélection
  const toggleUserSelection = (userId) => {
    setTempSelectedUsers((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId]
    );
  };

  const handleAssign = () => {
    setSelectedUsers(tempSelectedUsers);
    setIsModalOpen(false);
  };

 useEffect(() => {
  if (!selectedUsers || selectedUsers.length === 0) {
    setTempSelectedUsers([]);
  }
}, [selectedUsers]);

  const selectedUserAvatars = allUsers
  .filter((user) => selectedUsers?.includes(user._id))
  .map((user) => user.profileImageUrl);

  return (
    <div className="space-y-4 mt-2">
      {/* Bouton d’ouverture du modal */}
      {selectedUserAvatars.length === 0 && (
        <button
          onClick={() => setIsModalOpen(true)}
          className="flex items-center gap-2 px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          <LuUsers className="text-lg" />
          Ajouter un membre
        </button>
      )}
          {selectedUserAvatars.length > 0 && (
            <div className="cursor-pointer" onClick={()=>{setIsModalOpen(true)}}>
              <AvatarGroup avatars={selectedUserAvatars} maxVisible={3}/> 
            </div>
          )}
      {/* Fenêtre modale */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Sélectionner des utilisateurs"
      >
        <div className="space-y-4 h-[60vh] overflow-y-auto">
          {allUsers.map((user) => (
            <div
              key={user._id}
              className="flex items-center justify-between gap-4 p-3 border-b border-gray-200"
            >
              <div className="flex items-center gap-3">
                <img
                  src={`${BASE_URL}${user.profileImageUrl}`}
                  alt={user.name}
                  className="w-10 h-10 rounded-full"
                />

                <div>
                  <p className="font-medium text-gray-800 dark:text-white">
                    {user.name}
                  </p>
                  <p className="text-sm text-gray-500">{user.email}</p>
                </div>
              </div>
              <input
                type="checkbox"
                checked={tempSelectedUsers.includes(user._id)}
                onChange={() => toggleUserSelection(user._id)}
                className="w-4 h-4 text-blue-600 border-gray-300 rounded"
              />
            </div>
          ))}
        </div>

        {/* Boutons d’action */}
        <div className="flex justify-end gap-3 mt-4 border-t pt-3">
          <button
            onClick={() => setIsModalOpen(false)}
            className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md"
          >
            Annuler
          </button>
          <button
            onClick={handleAssign}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Valider
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default SelectUsers;
